import { SimpleListEntityResponse } from '@/modules/scientific-analysis-module/services/scientific-analysis-dtos'

export interface ScientificAnalysisFilterPanelPatientAgeState {
    entities: SimpleListEntityResponse[]
}
export const initialScientificAnalysisFilterPanelPatientAgeState =
    (): ScientificAnalysisFilterPanelPatientAgeState => ({
        entities: []
    })
